
import {
	Component, Vue, Prop,
} from 'vue-property-decorator';

@Component
export default class IconWithTooltip extends Vue {
	@Prop()
	public contentClass!: string;

	@Prop({ type: String })
	public iconClass!: string;

	@Prop()
	public id!: string;

	@Prop({ type: String })
	public tooltip!: string;

	@Prop({ type: String, default: 'right' })
	public position!: string;

	@Prop({ type: Boolean, default: false })
	public tooltipDark!: boolean;

	public isTooltipShown = false;
}
